import html_default from "./template.default.html?raw"
const app_theme = import.meta.env.VITE_APP_THEME
let html = ""
if ("default" == app_theme){
    html = html_default
}

export default {
  components: {},
  setup() {
    return {};
  },
  template: html,
};
